// extracted by mini-css-extract-plugin
export const wrapper = "promo-module--wrapper--1OKJi";
export const container = "promo-module--container--2ysaV";
export const subtitle = "promo-module--subtitle--2BmQN";
export const link = "promo-module--link--1I6al";